module.exports = __webpack_public_path__ + "img/taquets.74ead8ae.png";